import clsx from "clsx";
import { forwardRef, useEffect, useState } from "react";

import Icon from "~/components/Icon";

interface Props {
  className?: string;
  inputClassName?: string;
  name: string;
  value?: number | null;
  defaultValue?: number | null;
  placeholder?: string;
  min?: number;
  max?: number;
  step?: number | string;
  ariaLabel?: string;
  autoFocus?: boolean;
  isInvalid?: boolean;
  onChange?: (value: string) => void;
  withIcon?: boolean;
}

const NumberInput = forwardRef<HTMLInputElement, Props>((
    {
      className = null,
      inputClassName = null,
      name,
      value = 0,
      defaultValue = null,
      min = undefined,
      max = undefined,
      step = undefined,
      placeholder = "",
      autoFocus = undefined,
      ariaLabel = undefined,
      isInvalid = false,
      onChange = () => {
      },
      withIcon = false
    }, ref) => {
    if (name.length === 0) {
      throw new Error("Empty input name");
    }

    const [state, setState] = useState<string>(String(value ?? (defaultValue ?? 0)));

    useEffect(() => {
      onChange(state);
    }, [state]);

    useEffect(() => {
      setState(String(value));
    }, [value]);

    const icon = (
      <span className="absolute h-full p-3">
        <Icon v="keypad" />
      </span>
    );

    return (
      <div className={clsx(
        "relative flex items-center w-full",
        className
      )}>
        {withIcon ? icon : null}

        <input type="number"
               min={min}
               max={max}
               step={step}
               id={name}
               name={name}
               className={clsx(
                 "block",
                 {
                   "invalid": isInvalid,
                   "px-3": !withIcon,
                   "px-11": withIcon
                 },
                 inputClassName
               )}
               placeholder={placeholder}
               aria-label={ariaLabel}
               autoFocus={autoFocus}
               onChange={(e) => setState(e.target.value)}
               value={state}
               {...(ref ? { ref } : {})}
        />
      </div>
    );
  }
);
export default NumberInput;